import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, Fragment, useCallback, useMemo } from 'react';
import { BKJToggleButton, BKJToggleInputPillLabelWrapper, BKJToggleInputWrapper, BKJToggleSliderTrack, StyledButton, StyledCheckbox, } from './BKJToggleInput.styled.js';
const BKJToggleInputSwitch = forwardRef(({ onChange, name, checked, disabled, ...rest }, ref) => {
    const handleChange = useCallback(() => {
        !disabled && onChange({ target: { name, value: !Boolean(checked) } });
    }, [name, onChange, checked, disabled]);
    const isSelected = useMemo(() => !!checked, [checked]);
    return (_jsxs(BKJToggleInputWrapper, { ref: ref, onMouseDown: handleChange, ...rest, children: [_jsx(BKJToggleButton, { isSelected: isSelected, disabled: disabled }), _jsx(BKJToggleSliderTrack, { isSelected: isSelected, disabled: disabled })] }));
});
const BKJToggleInputPill = ({ variant, onChange, width, minWidth, checked, children, disabled, name, fontSize, }) => {
    const handleChange = useCallback((event) => {
        if (!disabled) {
            const nextValue = !checked;
            onChange({
                ...event,
                target: {
                    ...event.target,
                    name,
                    value: nextValue,
                    checked: nextValue,
                },
            });
        }
    }, [disabled, checked, onChange, name]);
    const ButtonVariantMap = {
        PurplePillLeft: checked ? 'PurplePill' : 'PurplePillOutlined',
        PurplePillRight: checked ? 'PurplePill' : 'PurplePillOutlined',
        PurpleNoBorderLeft: 'NoStyles',
        PurpleNoBorderRight: 'NoStyles',
        Switch: 'NoStyles',
    };
    return (_jsx(StyledButton, { onClick: handleChange, variant: ButtonVariantMap[variant], width: width, minWidth: minWidth, disabled: disabled, children: (() => {
            switch (variant) {
                case 'PurplePillLeft':
                case 'PurplePillRight':
                    return (_jsxs(Fragment, { children: [variant === 'PurplePillLeft' && (_jsx(BKJToggleInputPillLabelWrapper, { fontSize: fontSize, children: children })), _jsx(StyledCheckbox, { name: name, variant: "PurpleOutlined", isLeft: variant === 'PurplePillLeft', onChange: handleChange, readOnly: true, value: checked }), variant === 'PurplePillRight' && (_jsx(BKJToggleInputPillLabelWrapper, { fontSize: fontSize, children: children }))] }));
                case 'PurpleNoBorderLeft':
                case 'PurpleNoBorderRight':
                    return (_jsxs(Fragment, { children: [variant === 'PurpleNoBorderLeft' && (_jsx(BKJToggleInputPillLabelWrapper, { color: "PrimaryDefault", disabled: disabled, fontSize: fontSize, children: children })), _jsx(StyledCheckbox, { name: name, variant: "PurpleSolid", disabled: disabled, isLeft: variant === 'PurpleNoBorderLeft', onChange: handleChange, readOnly: true, value: checked }), variant === 'PurpleNoBorderRight' && (_jsx(BKJToggleInputPillLabelWrapper, { color: "PrimaryDefault", disabled: disabled, fontSize: fontSize, children: children }))] }));
                case 'Switch':
                default:
                    return _jsx(Fragment, {});
            }
        })() }));
};
export const BKJToggleInputComponentMap = {
    Switch: BKJToggleInputSwitch,
    PurplePillRight: BKJToggleInputPill,
    PurplePillLeft: BKJToggleInputPill,
    PurpleNoBorderRight: BKJToggleInputPill,
    PurpleNoBorderLeft: BKJToggleInputPill,
};
//# sourceMappingURL=BKJToggleInput.constants.js.map